import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/Store";
import { useLocation, useNavigate } from "react-router-dom";
import MuiPagination from "../../../common-components/pagination/Pagination";

import SelectList, { components } from "react-select";
import { Controller, useForm, useWatch } from "react-hook-form";
import ControlledSelectList from "../../../common-components/CommonReactSelect";
import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import axios from "axios";
import dayjs from "dayjs";
import CommonHeader from "../../../common-components/FUNCTION";
import PreviewDialog from "../PreviewExisting";
import { API } from "../../../constants/tableConstants/API";
import { debounce, useMediaQuery } from "@mui/material";
import { fetchBookBubDataPagination, resetBookBubPagination, setCurrentPageBookBub, setLoading, SetsortStateBookBub, updateselectedDealBookBub, updateselectedISBNListBookBub, updateselectedTitleListBookBub } from "../../../redux/reducers/BookBubReducer";
import { FetchISBNBookBub, setLoadingofDealBookBub, setLoadingofISBNBookBUb, setLoadingofTitleBookBub } from "../../../redux/reducers/ISBNBookBubReducer";
import { FetchTitleBookBub } from "../../../redux/reducers/TitleBookBubReducer";
import { FetchDealBookBub } from "../../../redux/reducers/DealBookBubReducer";

export interface OptionType {
  value: string;
  label: string;
}

const BookBuBTable: React.FC = () => {
  const { BookBubData, loading, error } = useSelector(
    (state: RootState) => state.BookBubReducer
  );
  const {
    ISBNBookBubOption,
    hasMore: hasMoreisbnBookbub,
    currentPage: currentpageisbnBookbub,
    limit: limitisbnBookbub,
    loading: loadingisbnBookbub,
  } = useSelector((state: RootState) => state.ISBNBookBubReducer);
  const {
    TitleBookBubOption,
    limit: limitTitleBookbub,
    hasMore: hasMoreTitleBookbub,
    currentPage: currentPageTitleBookBub,
    loading: loadingTitleBookbub,
  } = useSelector((state: RootState) => state.TitleBookBobReducer);
  const {
    DealBookBubOption,
    limit: limitDealBookBub,
    currentPage: currentPageDealBookBub,
    hasMore: hasMoreDealBookBub,
    loading: loadingDealBookBub
  } = useSelector((state: RootState) => state.DealBookBubReducer);
  const selectedIsbnListBookBub = useSelector(
    (state: RootState) => state.BookBubReducer.selectedIsbnListBookBub
  );
  const selectedTitleListBookBub = useSelector(
    (state: RootState) => state.BookBubReducer.selectedTitleListBookBub
  );
  const selectedDealBookBub = useSelector(
    (state: RootState) => state.BookBubReducer.selectedDealBookBub
  );

  const currentPageBookBub = useSelector(
    (state: RootState) => state.BookBubReducer.currentPageBookBub
  );
  const sortStateBookBub = useSelector(
    (state: RootState) => state.BookBubReducer.sortStateBookBub
  );

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const hasPreselected = useRef(false);
  const uploadedFileNames = useLocation()?.state?.uploadedFileName;
  const rowsPerPage = 10;
  const dispatch = useDispatch<AppDispatch>();
  const bookbubref = useRef<HTMLDivElement | null>(null);
  const { control, handleSubmit, watch, setValue, getValues } = useForm();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const ISBNOption = ISBNBookBubOption.map(
    (option: any) => ({
      label: option.label,
      value: option.label,
    })
  );
  const TitleOption = TitleBookBubOption.map((option: any) => ({
    label: option.label,
    value: option.label,
  }));
  const DealOption = DealBookBubOption.map((option: any) => ({
    label: option.label,
    value: option.label,
  }));

  const hasMore = useSelector((state: RootState) => state.BookBubReducer.hasMore);

  // Load filters from localStorage on mount
  useEffect(() => {
    const savedFilters = localStorage.getItem('bookbubFilters');
    if (savedFilters) {
      const { ISBN, TITLE, DEAL } = JSON.parse(savedFilters);
      if (ISBN?.length) {
        setValue('ISBN', ISBN);
        dispatch(updateselectedISBNListBookBub(ISBN));
      }
      if (TITLE?.length) {
        setValue('TITLE', TITLE);
        dispatch(updateselectedTitleListBookBub(TITLE));
      }
      if (DEAL?.length) {
        setValue('DEAL', DEAL);
        dispatch(updateselectedDealBookBub(DEAL));
      }
    }
  }, [dispatch, setValue]);

  // Save filters to localStorage whenever they change
  useEffect(() => {
    const filters = {
      ISBN: selectedIsbnListBookBub,
      TITLE: selectedTitleListBookBub,
      DEAL: selectedDealBookBub,
    };
    localStorage.setItem('bookbubFilters', JSON.stringify(filters));
  }, [selectedIsbnListBookBub, selectedTitleListBookBub, selectedDealBookBub]);

  // Clear filters when navigating to a different page
  useEffect(() => {
    const handlePageChange = () => {
      dispatch(updateselectedDealBookBub([]));
      dispatch(updateselectedISBNListBookBub([]));
      dispatch(updateselectedTitleListBookBub([]));
      setValue("ISBN", []);
      setValue("TITLE", []);
      setValue("DEAL", []);
      localStorage.removeItem('bookbubFilters');
    };

    return () => {
      if (location.pathname !== window.location.pathname) {
        handlePageChange();
      }
    };
  }, [location.pathname, dispatch, setValue]);

  const handleScroll = useCallback(() => {
    if (!bookbubref.current || loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = bookbubref.current;

    if (scrollTop + clientHeight >= scrollHeight - 50) {
      dispatch(setCurrentPageBookBub(currentPageBookBub + 1));
    }
  }, [dispatch, loading, hasMore]);

  useEffect(() => {
    console.log("handleScrollCalled", handleScroll);
    const scrollContainer = bookbubref.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  useEffect(() => {
    if (currentPageBookBub > 1) {
      console.log("currentPage in scroll", currentPageBookBub);
      dispatch(
        fetchBookBubDataPagination({
          page: currentPageBookBub,
          limit: rowsPerPage,
        heading: sortStateBookBub?.heading || "ISBN",
          sortType: sortStateBookBub?.sortType || 'desc',
          // secondarySort: sortStateBookBub?.secondarySort, // Include secondary sort
          filters: {
            TITLE: selectTitle,
            ISBN: selectIsbn,
            DEAL_DATE: selectDeal,
          },
        })
      );
    }
  }, [currentPageBookBub]);

  const watchedISBN= useWatch({ control, name: "ISBN" });
  const watchedTitle = useWatch({ control, name: "TITLE" });
  const watchedDEAL = useWatch({ control, name: "DEAL" });

  useEffect(() => {
    if (
      !Array.isArray(watchedISBN) &&
      !Array.isArray(watchedTitle) &&
      !Array.isArray(watchedDEAL)
    ) {
      return;
    }

    if (Array.isArray(watchedISBN) && watchedISBN.length > 0) {
      dispatch(updateselectedISBNListBookBub(watchedISBN));
    } else {
      dispatch(updateselectedISBNListBookBub([]));
    }

    if (Array.isArray(watchedTitle) && watchedTitle.length > 0) {
      dispatch(updateselectedTitleListBookBub(watchedTitle));
    } else {
      dispatch(updateselectedTitleListBookBub([]));
    }

    if (Array.isArray(watchedDEAL) && watchedDEAL.length > 0) {
      dispatch(updateselectedDealBookBub(watchedDEAL));
    } else {
      dispatch(updateselectedDealBookBub([]));
    }
  }, [watchedISBN, watchedTitle, watchedDEAL, dispatch]);

  const selectIsbn = selectedIsbnListBookBub?.map((data) => data.value);
  const selectTitle = selectedTitleListBookBub?.map((data) => data.value);
  const selectDeal = selectedDealBookBub?.map((data) => data.value);

  // useEffect(() => {
  //   dispatch(clearAsapData());
  // }, []);

  useEffect(() => {
    const filters = {
      TITLE: selectTitle,
      ISBN: selectIsbn,
      DEAL: selectDeal,
    };
    console.log("Fetching data with payload:", {
      page: currentPageBookBub,
      limit: rowsPerPage,
      heading: sortStateBookBub?.heading,
      sortType: sortStateBookBub?.sortType,
      // secondarySort: sortStateBookBub?.secondarySort,
      filters,
    });
    dispatch(
      FetchISBNBookBub({
        page: currentPageBookBub,
        limit: rowsPerPage,
        searchTerm: "",
        TITLE: filters.TITLE,
        DEAL_DATE: filters.DEAL,
      })
    );
    dispatch(
      FetchDealBookBub({
        page: currentPageBookBub,
        limit: rowsPerPage,
        searchTerm: "",
        ISBN: filters.ISBN,
        TITLE: filters.TITLE,
      })
    );
    dispatch(
      FetchTitleBookBub({
        page: currentPageBookBub,
        limit: rowsPerPage,
        searchTerm: "",
        ISBN: filters.ISBN,
        DEAL_DATE: filters.DEAL,
      })
    );
    dispatch(
      fetchBookBubDataPagination({
        page: currentPageBookBub,
        limit: rowsPerPage,
  heading: sortStateBookBub?.heading || "",
          sortType: sortStateBookBub?.sortType || '',   
        // secondarySort: sortStateBookBub?.secondarySort, // Include secondary sort
        filters: {
          TITLE: selectTitle,
          ISBN: selectIsbn,
          DEAL_DATE: selectDeal,
        },
      })
    );

    if (
      !selectedIsbnListBookBub &&
      !selectedTitleListBookBub &&
      !selectedDealBookBub
    ) {
      dispatch(resetBookBubPagination());
      dispatch(
        fetchBookBubDataPagination({
          page: 1,
          limit: 10,
          filters: {},
        })
      );
    }
  }, [selectedIsbnListBookBub, selectedTitleListBookBub, selectedDealBookBub]);

  const handleTitleBottom = () => {
    if (hasMoreTitleBookbub) {
      dispatch(setLoadingofTitleBookBub(true));
      dispatch(
        FetchTitleBookBub({ page: currentPageTitleBookBub + 1, limit: currentPageTitleBookBub })
      );
    }
  };

  const handleScrollToBottom = () => {
    if (hasMoreisbnBookbub) {
      dispatch(setLoadingofISBNBookBUb(true));
      dispatch(
        FetchISBNBookBub({ page: currentpageisbnBookbub + 1, limit: limitisbnBookbub })
      );
    }
  };

  const handleDealBottom = () => {
    if (hasMoreDealBookBub) {
      dispatch(setLoadingofDealBookBub(true));
      dispatch(
        FetchDealBookBub({
          page: currentPageDealBookBub + 1,
          limit: limitDealBookBub,
        })
      );
    }
  };

  const downloadBOOKBUBdata = async (data: any) => {
    dispatch(setLoading(true));
    try {
      const response = await axios.post(`${API.downloadBookBubExcelData}`, data, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      const formatDate = dayjs().format("MMMM-DD-YYYY-HHmmss");
      a.download = `BookBub ${formatDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      dispatch(setLoading(false));
    } catch (err: any) {
      console.error("Error downloading file:", err);
      alert("Failed to download the file. Please try again.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((inputValue: string) => {
        if (inputValue.length > 0) {
          dispatch(
            FetchISBNBookBub({
              page: currentPageBookBub,
              limit: rowsPerPage,
              searchTerm: inputValue,
              TITLE: selectTitle,
              DEAL_DATE: selectDeal,
            })
          );
        }
      }, 800),
    [limitisbnBookbub]
  );

  const debounceTitleSearch = useMemo(
    () =>
      debounce((inputValue: string) => {
        if (inputValue.length > 0) {
          dispatch(
            FetchISBNBookBub({
              page: currentPageTitleBookBub,
              limit: rowsPerPage,
              searchTerm: inputValue,
              ISBN: selectIsbn,
              DEAL_DATE: selectDeal,
            })
          );
        }
      }, 600),
    [limitTitleBookbub]
  );

  const debounceIsbn = useRef(
    debounce(
      (
        inputValue: string,
        page: number,
        limit: number,
        Title: any,
        Deal: any
      ) => {
        dispatch(
          FetchISBNBookBub({
            page,
            limit,
            searchTerm: inputValue,
            TITLE: Title,
            DEAL_DATE: Deal,
          })
        );
      },
      500
    )
  ).current;

  const debouncedFetchTitle = useRef(
    debounce(
      (
        inputValue: string,
        page: number,
        limit: number,
        Isbn: any,
        fileName: any
      ) => {
        dispatch(
          FetchTitleBookBub({
            page,
            limit,
            searchTerm: inputValue,
            ISBN: Isbn,
            DEAL_DATE: fileName,
          })
        );
      },
      500
    )
  ).current;

  const debouneDeal = useRef(
    debounce(
      (
        inputValue: string,
        page: number,
        limit: number,
        Isbn: any,
        Title: any
      ) => {
        dispatch(
          FetchDealBookBub({
            page,
            limit,
            searchTerm: inputValue,
            ISBN: Isbn,
            TITLE: Title,
          })
        );
      },
      500
    )
  );

   const handleSort = (heading: string, sortType: "asc" | "desc") => {
    dispatch(SetsortStateBookBub({ heading, sortType }));

    dispatch(setCurrentPageBookBub(1));

    console.log("currentPage in handlesort", currentPageBookBub);
    dispatch(
      fetchBookBubDataPagination({
        page: 1,
        limit: rowsPerPage,
        heading: heading,
        sortType: sortType,
        filters: {
          TITLE: selectTitle,
          ISBN: selectIsbn,
          DEAL_DATE: selectDeal,
        },
      })
    );
  };
  // const handleSort = (heading: string, sortType: "asc" | "desc") => {
  //   // Check if PRIMARY_ASIN is a valid column
  //   const isPrimaryAsinValid = Asapdata?.columns.includes("PRIMARY_ASIN");
  //   console.log("Is PRIMARY_ASIN valid?", isPrimaryAsinValid, "Columns:", Asapdata?.columns);

  //   if (!isPrimaryAsinValid) {
  //     console.warn("PRIMARY_ASIN column not found in data. Sorting only by primary column.");
  //   }

  //   const sortPayload = {
  //     heading,
  //     sortType,
  //     ...(isPrimaryAsinValid && { secondarySort: { heading: "PRIMARY_ASIN", sortType } }),
  //   };

  //   console.log("Sort payload:", sortPayload);

  //   dispatch(setsortStateBookBub(sortPayload));
  //   dispatch(setCurrentPageASAP(1));
  //   console.log("currentPage in handlesort", currentPageASAP);
  //   dispatch(
  //     fetchASAPDataPagination({
  //       page: 1,
  //       limit: rowsPerPage,
  //       heading,
  //       sortType,
  //       ...(isPrimaryAsinValid && { secondarySort: { heading: "PRIMARY_ASIN", sortType } }),
  //       filters: {
  //         TITLE: selectTitle,
  //         Marketing_Activity: selectMarketing,
  //         DEAL: selectedFile,
  //       },
  //     })
  //   );
  // };

  const handleClearAll = (e: any) => {
    e.preventDefault();
    // dispatch(updateselectedDealBookBub([]));
    dispatch(updateselectedDealBookBub([]));
    dispatch(updateselectedISBNListBookBub([]));
    dispatch(updateselectedTitleListBookBub([]));
    setValue("ISBN", []);
    setValue("TITLE", []);
    setValue("DEAL", []);
    localStorage.removeItem('BookBubFilters');
  };

  useEffect(() => {
    const isAllFieldsEmpty =
      !(selectedDealBookBub?.length ?? 0) &&
      !(selectedIsbnListBookBub?.length ?? 0) &&
      !(selectedTitleListBookBub?.length ?? 0);
    setButtonDisabled(isAllFieldsEmpty);
  }, [selectedDealBookBub, selectedIsbnListBookBub, selectedTitleListBookBub]);

  const formatHeader = (header: string): string => {
    return header
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  // useEffect(() => {
    
  //   if (isbnReducer.isbns?.length) {
  //     dispatch(setIsbnNumberOptions(isbn_number_options))

  //     dispatch(setIsbnTitleOptions(isbn_title_options))


  //   }
  // }, [isbnReducer.isbns?.length]);

  //  const changeIsbnInfo = (event: any) => {
  //   if (!event.target.value?.length) {
  //     dispatch(setIsbnNumberOptions([]))
  //     dispatch(setIsbnTitleOptions([]))
  //   }
  //   if (event.target.name === "title") {
  //     const titleIsbns = watch("title").map((title: any) => title.value);
  //     const isbnFilteredData =
  //       numberOptions?.filter((isbn) => titleIsbns.includes(isbn.value)) || [];
  //     setValue("isbn", isbnFilteredData);
  //   } else if (event.target.name === "isbn") {
  //     const isbnsList = watch("isbn").map((isbn: any) => isbn.value);

  //     const titleFilteredData =
  //       titleOptions?.filter((title) => isbnsList.includes(title.value)) || [];
  //     setValue("title", titleFilteredData);
  //   }
  // };

  return (
    <>
      <div className="flex md:flex-row flex-col md:gap-2">
        <div className="w-full py-1">
          <p className="text-[#e31c23] font-bold "> ISBN</p>
          <Controller
            name="ISBN"
            control={control}
            render={({ field }) => {
              return (
                <div className="w-full">
                  <SelectList
                    {...field}
                    id="ISBN"
                    options={ISBNOption}
                    isClearable={true}
                    placeholder="Select Isbn"
                    hideSelectedOptions={false}
                    menuPortalTarget={document.body}
                    onMenuOpen={() => {
                      dispatch(setLoadingofISBNBookBUb(false));
                      dispatch(
                        FetchISBNBookBub({
                          page: 1,
                          limit: rowsPerPage,
                          searchTerm: "",
                          TITLE: selectTitle,
                          DEAL_DATE: selectDeal,
                        })
                      );
                    }}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        dispatch(setLoadingofISBNBookBUb(true));
                        debounceIsbn(
                          inputValue,
                          currentpageisbnBookbub,
                          rowsPerPage,
                          selectTitle,
                          selectDeal
                        );
                      }
                    }}
                    onChange={(e) => {
                      dispatch(setLoadingofISBNBookBUb(true));
                      field.onChange(e);
                      dispatch(setCurrentPageBookBub(1));
                    }}
                    onMenuScrollToBottom={handleScrollToBottom}
                    menuPlacement="auto"
                    isMulti
                    className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                    components={{
                      MultiValueContainer: (props) => (
                        <components.MultiValueContainer {...props}>
                          <div className="flex">{props.children}</div>
                        </components.MultiValueContainer>
                      ),
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        pointerEvents: loadingisbnBookbub ? "none" : "auto",
                      }),
                      input: (provided) => ({
                        ...provided,
                        position: `${
                          watch("ISBN")?.length
                            ? "relative"
                            : "absolute"
                        }`,
                        pointerEvents: loadingisbnBookbub ? "none" : "auto",
                        left: 6,
                        marginRight: "10px",
                        caretColor: loadingisbnBookbub ? "transparent" : "auto",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor:
                          state.isSelected || state.isFocused ? "#E6E6E6" : "",
                        color: state.isSelected ? "black" : "black",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "6px",
                        minWidth: "none",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: loadingisbnBookbub ? -1 : 1050,
                        position: "absolute",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                      }),
                      valueContainer: (provided) => ({
                        position: "relative",
                        maxWidth: isSmallScreen ? "52vw" : "22vw",
                        width: "100%",
                        paddingLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        height: "40px",
                        paddingRight: "8px",
                        overflowX: "auto",
                        overflowY: "hidden",
                        minWidth: "50px",
                        boxSizing: "border-box",
                      }),
                      control: (provided) => ({
                        display: "flex",
                        height: "40px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }),
                      menuList: (provided) => ({
                        maxHeight: "200px",
                        overflow: "hidden",
                        overflowY: "auto",
                      }),
                      clearIndicator: () => ({
                        marginLeft: "15px",
                        marginTop: "5px",
                        color: "gray",
                      }),
                    }}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="w-full py-1">
          <p className="text-[#e31c23] font-bold "> TITLE</p>
          <Controller
            name="TITLE"
            control={control}
            render={({ field }) => (
              <div className="w-full">
                <SelectList
                  {...field}
                  id="BookbubTitle"
                  options={TitleOption}
                  isClearable={true}
                  hideSelectedOptions={false}
                  placeholder="Select Title"
                  menuPortalTarget={document.body}
                  onChange={(e) => {
                    dispatch(setLoadingofTitleBookBub(true));
                    field.onChange(e);
                    dispatch(setCurrentPageBookBub(1));
                  }}
                  onMenuOpen={() => {
                    dispatch(setLoadingofTitleBookBub(false));
                    dispatch(
                      FetchTitleBookBub({
                        page: 1,
                        limit: rowsPerPage,
                        searchTerm: "",
                        ISBN: selectIsbn,
                        DEAL_DATE: selectDeal,
                      })
                    );
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      dispatch(setLoadingofTitleBookBub(true));
                      debouncedFetchTitle(
                        inputValue,
                        currentPageTitleBookBub,
                        rowsPerPage,
                        selectIsbn,
                        selectDeal 
                      );
                    }
                  }}
                  onMenuScrollToBottom={handleTitleBottom}
                  menuPlacement="auto"
                  isMulti
                  className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                  components={{
                    MultiValueContainer: (props) => (
                      <components.MultiValueContainer {...props}>
                        <div className="flex">{props.children}</div>
                      </components.MultiValueContainer>
                    ),
                  }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      pointerEvents: loadingTitleBookbub ? "none" : "auto",
                    }),
                    input: (provided) => ({
                      ...provided,
                      position: `${
                        watch("TITLE")?.length ? "relative" : "absolute"
                      }`,
                      pointerEvents: loadingTitleBookbub ? "none" : "auto",
                      left: 6,
                      marginRight: "10px",
                      caretColor: loadingTitleBookbub ? "transparent" : "auto",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor:
                        state.isSelected || state.isFocused ? "#E6E6E6" : "",
                      color: state.isSelected ? "black" : "black",
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "6px",
                      minWidth: "none",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: loadingTitleBookbub ? -1 : 1050,
                      position: "absolute",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                    }),
                    valueContainer: (provided) => ({
                      position: "relative",
                      maxWidth: isSmallScreen ? "52vw" : "20vw",
                      width: "100%",
                      paddingLeft: "6px",
                      display: "flex",
                      alignItems: "center",
                      height: "40px",
                      paddingRight: "8px",
                      overflowX: "auto",
                      overflowY: "hidden",
                      minWidth: "50px",
                      boxSizing: "border-box",
                    }),
                    control: (provided) => ({
                      display: "flex",
                      height: "40px",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }),
                    menuList: (provided) => ({
                      maxHeight: "200px",
                      overflow: "hidden",
                      overflowY: "auto",
                    }),
                    clearIndicator: () => ({
                      marginLeft: "15px",
                      marginTop: "5px",
                      color: "gray",
                    }),
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className="w-full py-1">
          <p className="text-[#e31c23] font-bold ">DEAL DATE</p>
          <Controller
            name="DEAL"
            control={control}
            render={({ field }) => (
              <div className="w-full">
                <SelectList
                  {...field}
                  id="DEAL_DATE"
                  options={DealOption}
                  isClearable={true}
                  hideSelectedOptions={false}
                  placeholder="Select Deal Date"
                  menuPortalTarget={document.body}
                  menuPlacement="auto"
                  isMulti
                  onMenuOpen={() => {
                    dispatch(setLoadingofDealBookBub(false));
                    dispatch(
                      FetchDealBookBub({
                        page: 1,
                        limit: rowsPerPage,
                        searchTerm: "",
                        ISBN:selectIsbn,
                        TITLE: selectTitle,
                      })
                    );
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      dispatch(setLoadingofDealBookBub(true));
                      debouneDeal.current(
                        inputValue,
                        currentPageDealBookBub,
                        rowsPerPage,
                        selectIsbn,
                        selectTitle
                      );
                    }
                  }}
                  onChange={(e) => {
                    dispatch(setLoadingofDealBookBub(true));
                    field.onChange(e);
                    dispatch(setCurrentPageBookBub(1));
                  }}
                  onMenuScrollToBottom={handleDealBottom}
                  className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                  components={{
                    MultiValueContainer: (props) => (
                      <components.MultiValueContainer {...props}>
                        <div className="flex">{props.children}</div>
                      </components.MultiValueContainer>
                    ),
                  }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      pointerEvents: loadingDealBookBub ? "none" : "auto",
                    }),
                    input: (provided) => ({
                      ...provided,
                      position: `${
                        watch("DEAL")?.length ? "relative" : "absolute"
                      }`,
                      pointerEvents: loadingDealBookBub ? "none" : "auto",
                      left: 6,
                      marginRight: "10px",
                      caretColor: loadingDealBookBub ? "transparent" : "auto",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor:
                        state.isSelected || state.isFocused ? "#E6E6E6" : "",
                      color: state.isSelected ? "black" : "black",
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "6px",
                      minWidth: "none",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: loadingDealBookBub ? -1 : 1050,
                      position: "absolute",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                    }),
                    valueContainer: (provided) => ({
                      position: "relative",
                      maxWidth: isSmallScreen ? "52vw" : "22vw",
                      width: "100%",
                      paddingLeft: "6px",
                      display: "flex",
                      alignItems: "center",
                      height: "40px",
                      paddingRight: "8px",
                      overflowX: "auto",
                      overflowY: "hidden",
                      minWidth: "50px",
                      boxSizing: "border-box",
                    }),
                    control: (provided) => ({
                      display: "flex",
                      height: "40px",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }),
                    menuList: (provided) => ({
                      maxHeight: "200px",
                      overflow: "hidden",
                      overflowY: "auto",
                    }),
                    clearIndicator: () => ({
                      marginLeft: "15px",
                      marginTop: "5px",
                      color: "gray",
                    }),
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className=" flex flex-col md:flex-row justify-center items-center md:gap-2">
          <button
            disabled={buttonDisabled}
            className={` ${
              buttonDisabled
                ? "bg-[#f87171] cursor-not-allowed"
                : "bg-[#e31c23] hover:bg-red-700 cursor-pointer"
            }  text-white flex justify-center items-center w-full sm:w-[70px] rounded-md  h-[38px] mt-4 sm:mt-12 font-poppins font-semibold border border-none`}
            onClick={handleClearAll}
          >
            Clear All
          </button>
          <button
            // disabled={!BookBubData?.values?.length}
            className={` ${
              loading || !BookBubData?.values?.length
                ? "bg-[#f87171] cursor-not-allowed"
                : "bg-[#e31c23]  cursor-pointer hover:bg-red-700"
            }  text-white flex justify-center items-center
                         w-full sm:w-[70px]  rounded-md  h-[38px] mt-2 md:mb-0 mb-1 sm:mt-12 font-poppins font-semibold border border-none `}
            onClick={(e) => {
              e.preventDefault();
              const isPrimaryAsinValid = BookBubData?.columns.includes("PRIMARY_ASIN");
              console.log("Export payload:", {
                ISBN: selectIsbn || [],
                TITLE: selectTitle || [],
                DEAL_DATE: selectDeal || [],
                heading: sortStateBookBub?.heading || "",
                sortType: sortStateBookBub?.sortType || "",
                // secondarySort: isPrimaryAsinValid
                //   ? sortStateBookBub?.secondarySort || { heading: "PRIMARY_ASIN", sortType: sortState?.sortType || "asc" }
                //   : undefined,
              });
              downloadBOOKBUBdata({
                ISBN: selectIsbn || [],
                TITLE: selectTitle || [],
                DEAL_DATE: selectDeal || [],
                heading: sortStateBookBub?.heading || "",
                sortType: sortStateBookBub?.sortType || "",
                // secondarySort: isPrimaryAsinValid
                //   ? sortState?.secondarySort || { heading: "PRIMARY_ASIN", sortType: sortState?.sortType || "asc" }
                //   : undefined,
              });
            }}
          >
            Export
          </button>
        </div>
      </div>
      {BookBubData?.values?.length ? (
        <div
          ref={bookbubref}
          style={{ borderTop: "1px solid gray" }}
          className={`  overflow-auto max-h-[72vh] 4k:max-h-[50vh] 5k:max-h-[45vh] 3xl:max-h-[65vh] 2xl:max-h-[67vh] w-full`}
        >
          <table className="border-collapse w-full min-w-max  table-auto border-2 border-gray-400">
            <thead
              style={{ borderBottom: "1px solid gray", height: "60px" }}
              className="sticky top-[0px] z-10 bg-gray-200 m-header"
            >
              <tr>
                {BookBubData?.columns.map((col: any, index: any) => (
                  <th
                    key={index}
                    style={{
                      border: "1px solid gray",
                    }}
                    className={`px-6 text-gray-800 font-semibold border border-black cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis ${
                      col === "MARKETING_ACTIVITY"
                        ? "w-[150px]  2xl:w-[200px] 4k:w-[250px]"
                        : col === "START_DATE"
                        ? "w-[100px] 2xl:w-[120px] 4k:w-[170px]"
                        : col === "END_DATE"
                        ? "w-[100px] 2xl:w-[120px]"
                        : col === "PRIMARY_ASIN"
                        ? "w-[100px] 2xl:w-[120px]"
                        : col === "TITLE"
                        ? "w-[180px] 2xl:w-[220px] 4k:w-[350px]"
                        : col === "COVERAGE"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[150px] "
                        : col === "CATEGORY"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "STATUS"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "REJECTION_REASON"
                        ? "w-[80px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "ORIGIN"
                        ? "w-[100px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "CONFIRMATION_ID"
                        ? "w-[130px] 2xl:w-[130px] 4k:w-[170px]"
                        : col === "DEAL"
                        ? "w-[150px] 2xl:w-[130px] 4k:w-[170px]"
                        : ""
                    }`}
                  >
                    <CommonHeader
                      column={col}
                      data={{ values: BookBubData.values }}
                      sortState={sortStateBookBub}
                      onSort={handleSort}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {BookBubData?.values.map((row: any, i: any) => (
                <tr key={i}>
                  {row.map((cell: any, j: any) => {
                    const isDash =
                      cell === null ||
                      cell === undefined ||
                      cell === "" ||
                      (typeof cell === "string" &&
                        cell.toLowerCase() === "nan");
                    const displayValue = isDash ? "-" : cell;
                    const colName = BookBubData.columns[j];
                    return (
                      <td
                        key={j}
                        className={`px-5 h-[50px]  py-1 2xl:py-3 5k:py-10 text-gray-700 border border-black text-sm ${
                          displayValue === "-" ? "text-center" : ""
                        }`}
                        style={{
                          border: "1px solid gray",
                          width: colName === "TITLE" ? "300px" : "auto",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          verticalAlign: "top",
                        }}
                      >
                        {displayValue}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="h-[30vh] flex items-center justify-center text-gray-500 font-semibold text-[15px] border border-gray-300">
          No data available
        </div>
      )}
    </>
  );
};

export default BookBuBTable;